var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCcVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.475.215H6.77v6.689H.475z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.828.092h5.153V7H.828z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0023A0",
    d: "M3.19 4.528c.146-.384.698-1.87.698-1.87-.01.018.143-.388.232-.639l.118.578.407 1.93H3.189zM5.35.215H3.998c-.42 0-.735.118-.92.556L.475 6.904h1.841s.301-.826.37-1.007l2.243.004c.054.233.213 1.002.213 1.002H6.77L5.35.215z",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0023A0",
    d: "M7.145 9.004L5.432 13.78l-.183-.97-.001-.003-.613-3.218c-.106-.442-.413-.574-.793-.59H1.017L1 9.121c.682.18 1.292.442 1.827.768L4.389 16h1.854L9 9.003H7.145z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0023A0",
    d: "M4.289 2.896c-.599-.31-.969-.516-.964-.83.001-.278.311-.575.984-.575.563-.01.967.12 1.285.257l.154.076.233-1.45A4.216 4.216 0 0 0 4.442.09c-1.698 0-2.891.91-2.902 2.209-.01.962.854 1.5 1.503 1.82.67.326.894.537.893.83-.007.448-.537.652-1.029.652-.687 0-1.053-.1-1.615-.35l-.223-.107-.24 1.498c.401.187 1.143.349 1.913.357 1.803 0 2.976-.898 2.99-2.286.007-.763-.452-1.341-1.443-1.818",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0023A0",
    d: "M10.154 9L9 16h1.846L12 9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcVisa);
export default __webpack_public_path__ + "static/media/cc-visa.51b7600ac6147da8b05f6b0b4271094a.svg";
export { ForwardRef as ReactComponent };